import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { PageNames, PageContext } from '../Home/HomeTopMailConfirm';
import { Box, Button } from '@mui/material';
import { Title } from '../Component/Title';
import { Info } from "../Component/Info"
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { HeldTimesContext } from '../Root/CompetitionRoot';

/**
 * メール登録完了画面
 */
export function KaguMailComplete() {

    const [t] = useTranslation();

    const {setPage} = useContext(PageContext);

    const heldTimesOption = useContext(HeldTimesContext);

    return(
        <>
            <Box>
                <Title>
                    {t("KaguMailComplete.Title", heldTimesOption)}
                </Title>
                <Info>
                    {t("KaguMailComplete.Text1", heldTimesOption)}
                </Info>
                <Grid2 container spacing={1} mt={1}>
                    <Grid2>
                        <Button variant="outlined" onClick={() => setPage(PageNames.KaguTop)}>{t("Common.Back")}</Button>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    );
}